import { render, staticRenderFns } from "./BGrimmTaxInvoiceComponent.vue?vue&type=template&id=13c1e1aa&"
import script from "./BGrimmTaxInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./BGrimmTaxInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports